import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  padding-bottom: ${space[5]};
`;

export const InfoAlert = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space[3]};
  padding: ${space[3]} ${space[4]};
  background: ${semantic.bg.infoSubtle};
  color: ${semantic.text.info};
  border-radius: ${layout.borderRadiusMd};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
`;

export const InfoIconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: ${semantic.icon.info};
  flex-shrink: 0;
`;

export const InfoAlertText = styled.span`
  flex: 1;
  line-height: 1.4;
`;

export const InfoAlertLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  color: ${semantic.text.info};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const DismissButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space[1]};
  color: ${semantic.icon.info};
  border-radius: ${layout.borderRadius};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;

  &:hover {
    background: ${semantic.bg.surfaceStrong};
  }
`;

export const FooterInner = styled.div`
  padding: ${space[4]} ${space[5]};
`;

export const InlinePanel = styled.section`
  background: ${colors.white};
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
`;

export const InlineHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[6]} ${space[5]} ${space[3]};
`;

export const InlineTitle = styled.h2`
  font-family: ${bodyFont};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const InlineCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space[1]};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  font-size: ${fonts.size.xl};
  line-height: 1;
  border-radius: ${layout.borderRadius};
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const InlineBody = styled.div`
  padding: 0 ${space[5]};
`;

export const InlineFooter = styled.div`
  border-top: 1px solid ${semantic.border.subtle};
`;

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  padding: ${space[4]} 0 ${space[3]};
`;

export const SuccessTitle = styled.p`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const SuccessBody = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  line-height: 1.4;
  margin: 0;
`;

export const ErrorMessage = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.danger};
  background: ${semantic.bg.dangerSubtle};
  border-radius: ${layout.borderRadiusMd};
  padding: ${space[3]} ${space[4]};
  margin: 0;
`;
